/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/search.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const SearchIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.542a8.542 8.542 0 1115.781 4.534l.254.21.027.024c.681.564 1.357 1.125 2.025 1.744.801.743.912 1.899.133 2.705a20.504 20.504 0 01-.46.46c-.806.78-1.961.67-2.704-.133a47.855 47.855 0 01-1.743-2.025l-.023-.028-.21-.254A8.542 8.542 0 010 8.541zm2.083 0a6.458 6.458 0 1112.917 0 6.458 6.458 0 01-12.917 0z"
        fill="currentColor"
      />
    </svg>
  ),
);
export default SearchIcon;
